import UIIcon from 'UIComponents/icon/UIIcon';
import { EDGE_TOOLBAR_ICON_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const SectionIcon = ({
  isEmbed,
  isStaticSection
}) => {
  if (isEmbed) {
    return /*#__PURE__*/_jsx(UIIcon, {
      name: "embed",
      size: EDGE_TOOLBAR_ICON_SIZE
    });
  }
  if (isStaticSection) {
    return /*#__PURE__*/_jsx(UIIcon, {
      name: "fixedLayout",
      size: EDGE_TOOLBAR_ICON_SIZE
    });
  }
  return /*#__PURE__*/_jsx(UIIcon, {
    name: "section",
    size: EDGE_TOOLBAR_ICON_SIZE
  });
};
export default SectionIcon;